/**
* Получает текущий год для футера.
*/
const YearNow = () => {
  const today = new Date();
  const year_now = today.getFullYear();
  return (
    year_now
  );
};

export default YearNow;
